/** Cash sessions at the point of sale: not managed, optional, required to sell */
export type CashSessionMode = 'disabled' | 'optional' | 'required';

export class PosConfig {
  showTopSales?: boolean;
  topSalesLimit?: number;

  filterByBrand?: boolean;
  filterByCategory?: boolean;
  filterBySupplier?: boolean;

  automaticallyAddToCart?: boolean;
  showProductImages?: boolean;
  scanSound?: boolean;

  // Cash sessions (none: disabled), cash counted by denomination, expected
  // cash hidden from the cashier (not admin) until closed, closing note
  // required above a cash difference (null: never)
  cashSessionMode?: CashSessionMode;
  cashCountByDenomination?: boolean;
  blindCashCount?: boolean;
  cashDifferenceNoteThreshold?: number;

  constructor() {
    this.filterByBrand = false;
    this.showTopSales = true;
    this.topSalesLimit = 18;
    this.filterByCategory = true;
    this.filterBySupplier = false;
    this.automaticallyAddToCart = true;
    this.showProductImages = true;
    this.scanSound = true;
    this.cashSessionMode = 'disabled';
    this.cashCountByDenomination = true;
    this.blindCashCount = false;
    this.cashDifferenceNoteThreshold = null;
  }
}
